
      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  var parcelRequire = $parcel$global["parcelRequire94c2"];
var parcelRegister = parcelRequire.register;
parcelRegister("1soqt", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.init = void 0;

var $10fb5a70621fd538$var$_jquery = $10fb5a70621fd538$var$_interopRequireDefault((parcelRequire("4kMWr")));
function $10fb5a70621fd538$var$_interopRequireDefault(e) {
    return e && e.__esModule ? e : {
        "default": e
    };
}
var $10fb5a70621fd538$var$init = module.exports.init = function init() {
    (0, $10fb5a70621fd538$var$_jquery["default"])(".sub-nav-toggle").on("click", function() {
        (0, $10fb5a70621fd538$var$_jquery["default"])(this).parents(".sub-nav-container").find(".sub-nav-box").slideToggle();
        (0, $10fb5a70621fd538$var$_jquery["default"])(this).toggleClass("open");
    });
};

});


//# sourceMappingURL=subNavToggle.module.d08c6c8b.js.map
